import styled from 'styled-components'

export const HeaderAssetSection = styled.div`
	padding: 15px;
	color: ${p => p.theme.COLORS.textw};
	background-color: ${p => p.theme.COLORS.header};
`
